import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { DataService } from "../Data.service";
import { CountsData, DgHubClientService, TradeDataEvent } from "../dg-hub-client.service";
import { DGDrawingServiceGlobal, DrawingService } from "../DrawingService";
import * as moment from "moment";
import { MatDialog } from "@angular/material/dialog";
import { EventsComponent } from "src/app/Dialogs/Events/Events.component";
import { Subject } from "rxjs";
import { retracementTimeRangeCartessians } from "../RetracementAccesability.service";

@Injectable({
  providedIn: "root",
})

export class SignalService {
public signalPut: HTMLAudioElement;
public signalCall: HTMLAudioElement;
public signalChurch3: HTMLAudioElement;
public signalChurch2: HTMLAudioElement;
public signalChurch1: HTMLAudioElement;

  public blinks:Map<string,string> = new Map<string,string>();
  constructor(
    private dataService:DataService, 
    private toastr: ToastrService,
    public dialog: MatDialog,
    
    ) {

    this.signalPut = new Audio();
    this.signalPut.src = "alarm-short.wav";
    this.signalPut.volume = 0.5;

    this.signalCall = new Audio();
    this.signalCall.src = "hoteldong-1.wav";
    this.signalCall.volume = 0.5;

    
    this.signalChurch1 = new Audio();
    this.signalChurch1.src = "church-1.wav";

    this.signalChurch2 = new Audio();
    this.signalChurch2.src = "church-2.wav";

    this.signalChurch3 = new Audio();
    this.signalChurch3.src = "church-3.wav";
    

    this.dataService.getHubCLientService().SendTomorrowDayDataTick.subscribe((l)=>{
      this.tomorrowDayEventsToCountData(l);
      console.log("SendTomorrowDayDataTick");
      this.previusDayCountsData.next(this.currentDataMode)
    })

    this.dataService.getHubCLientService().SendLastTomorrowDayDataTick.subscribe((l)=>{
      this.pushSingletomorrowDayEventsToCountData(l);
      this.previusDayCountsData.next(this.currentDataMode)
   //   this.tomorrowDayEventsToCountData(l);
   //   console.log("SendTomorrowDayDataTick");
   //   this.previusDayCountsData.next(this.currentDataMode)
    })

    // this._hubservice.getSignals().then((l)=>{
     

    //   this.lastTenNotifications = l.items.map((k)=>{
    //     return new CountsData(k);
    //   });

    //   if(this.lastTenNotifications.length>10)
    //   {
    //     this.lastTenNotifications = this.lastTenNotifications.slice(-10)
    //   }

    // })

  }
  public currentDataMode:number = 0;
  public lastSymbol:string = '';
  public lastfSum:number = 0;
  public lastsSum:number = 0;

  public clearNotes()
  {
      this.toastr.clear();
  }

  public showAllNotices()
  {
    const dialogRef = this.dialog.open(EventsComponent, {
      width: '600px',
      height: 'auto',
      maxHeight: window.innerHeight - 30 + 'px',
      maxWidth: '100vw',
      panelClass: 'my-css-class'
    });
 
     
  }

  public lastSignalsNotifications:CountsData[] = [];
  public lastRatio:number;
  public lastNotifCOmpute:number = 7;
  public paercentHeightRatio = 0.25;
  public strNotification:string = "";
  public computePutCallRatio()
  { 
      if(this.lastSignalsNotifications.length>=4)
      {
        var puts = this.lastSignalsNotifications.filter((l)=>{
          return l.symbol.includes(" P");
        })

        var calls = this.lastSignalsNotifications.filter((l)=>{
          return l.symbol.includes(" C");
        })

        this.strNotification="<div>Puts</div>"
        puts.forEach(element => {
          this.strNotification+=`<div>Strike:${element.strike} Size:${element.lastSize} Price:${element.tradeInfo.price} Size*Price: ${element.sizePrice}</div>`
        });

        var putSum = puts.reduce((accumulatedSum, currentObject) => {
          return accumulatedSum + currentObject.sizePrice;
        }, 0);
        this.strNotification+=`<div>Puts Sum: ${putSum}</div><br>`;

        this.strNotification+="<div>Calls</div>"
        calls.forEach(element => {
          this.strNotification+=`<div>Strike:${element.strike} Size:${element.lastSize} Price: ${element.tradeInfo.price} Size*Price: ${element.sizePrice}</div>`
        });
       

        var callSum = calls.reduce((accumulatedSum, currentObject) => {
          return accumulatedSum + currentObject.sizePrice;
        }, 0)
        this.strNotification+=`<div>Calls Sum: ${callSum}</div><br>`;


        var diff = callSum - putSum;
        var base = Math.min(callSum, putSum);

        this.strNotification+=`<div>CallSum-PutSum: ${diff}</div>`;
        
       
        // if(putSum>callSum&&callSum>0)
        // {
        //   var percentResult = 100*(putSum/callSum)
        //   return percentResult;
        // }

        if(base>0)
        {
            var percentResult = 100*(diff/base);
            this.strNotification+=`<div>CallSum-PutSum/ Math.min(callSum, putSum): ${(diff/base)}</div>`;
            this.strNotification+=`<div>Percent: ${percentResult}%</div><br><br>`;
           

            jQuery(`#compBar`).html(
              `${this.strNotification}`
            );
            return percentResult;
        }
        else
        {
          this.strNotification+=`<div>Math.min(callSum, putSum) = 0</div><br><br>`;
          jQuery(`#compBar`).html(
            `${this.strNotification}`
          );
        }


       // var diff = callSum - putSum;
       // var base = Math.min(callSum, putSum);

        return 0;


      }
  }

  public prepareEventsDataByState(state:number)
  {

    var eventsDataPrevious = this.eventsTomorrowDayData ;
    var eventsData = this.eventsData;

  //   [...this.signalService.eventsData,...eventsDataPrevious];
  }

 public newCountsData:Subject<CountsData> = new Subject<CountsData>();
 public previusDayCountsData:Subject<number> = new Subject<number>();

  public checkStrikesSum(item: CountsData)
  {
    var item = new CountsData(item);

    this.lastSignalsNotifications.push(item);
    this.lastSignalsNotifications = this.lastSignalsNotifications.slice(-this.lastNotifCOmpute);

    if(item.lastSize>=this.dataService.appSettings.SingalSizeAmount&&!(this.lastSymbol == item.symbol&&this.lastfSum == item.firstCount&&this.lastsSum == item.secondCount))
    {
      var time = moment(item.dateTime).format("hh:mm A");
      var timeColor = (time.includes("AM"))?"blue-text":"yellow-txt";
      var color = (item.symbol.includes(" C")?'green-txt':'red-txt');
      var pnlColor = (item.itm)?'green-txt':'red-txt';

      if(this.eventsData)
      {
         this.eventsData.push(item);
      }
     
     this.newCountsData.next(item);
      

        this.blinks.set(item.symbol,item.symbol);

        if(DGDrawingServiceGlobal.drawingService().alertsEnabled)
        {

        var step1 = 25000;
        var step2 = 50000;
        var step3 = 100000;
       

        // var step1 = 1000;
        // var step2 = 2000;
        // var step3 = 5000;

        var value = item.costOfTrade;
        
        if(item.symbol.includes(" C"))
        {
          //console.log("CallSignal");
          this.signalCall.play();
        }

        if(item.symbol.includes(" P"))
        {
          //console.log("PutSignal");
          this.signalPut.play();
        }

        if(value>=step1&&value<step2)
        {
          //console.log("FIRSTSIGNAL")
          this.signalChurch1.play();
        }

        if(value>=step2&&value<step3)
        {
          //console.log("SECONDSIGNAL")
          this.signalChurch2.play();
        }

        if(value>=step3)
        {
          //console.log("ThirdSIGNAL")
          this.signalChurch3.play();
        }
        
 
        }
       

        setTimeout(()=>{
          this.blinks.delete(item.symbol);
        },5*1000)
    }

    this.lastSymbol = item.symbol;
    this.lastfSum = item.firstCount;
    this.lastsSum = item.secondCount;
  }

  public tomorrowDayEventsToCountData(data:TradeDataEvent[])
  {
    var dataEvents = data.map(l=>{
      var countDtaa = new TradeDataEvent(l)
        return countDtaa.CountsDataConverted
    })

    this.eventsTomorrowDayData = dataEvents;
      
  }

  public pushSingletomorrowDayEventsToCountData(data:TradeDataEvent)
  {

    var countDtaa = new TradeDataEvent(data);
    this.eventsTomorrowDayData.push(countDtaa.CountsDataConverted);
      

    if(this.currentDataMode==1){
      DGDrawingServiceGlobal.drawingService().notificationDisplayer.drawSingleSignal(countDtaa.CountsDataConverted);
    }
  }



  public eventsData:CountsData[];
//  public eventsTomorrowDayData:CountsData[];
  public eventsTomorrowDayData:CountsData[];
  public getEvents() {
    return new Promise((resolve, reject) => {
      this.dataService.getHubCLientService().getSignals().then((l) => {
        //console.log("getEvents() ",l);
        var json = JSON.stringify(l); // Jeśli potrzebujesz tego JSON, ale wydaje się, że nie jest używany
        const mappedData = l.items.map((k) => new CountsData(k));
        // this.dataSource = new MatTableDataSource(mappedData.reverse());
        
        // Tutaj zwracasz przetworzone dane za pomocą resolve
        resolve(mappedData);
      }).catch(error => reject(error)); // Dodanie obsługi błędów
    });
  }

  public redrawTImeOut:any;
  public signalSeriesIndexMap: Map<number, retracementTimeRangeCartessians> = new Map<number, retracementTimeRangeCartessians>();
  public addOrUpdateCartessianMap(serieIndex:number,xstart:number,xend:number, priceStart:number, priceEnd:number)
  {
    let range = new retracementTimeRangeCartessians();

    ////console.log("signal_serieIndex_addOrUpdateCartessianMap",serieIndex);
    range.startX = xstart;
    range.endX = xend;
    range.priceStart = priceStart;
    range.priceEnd = priceEnd;
    range.serieIndex = serieIndex;

    this.signalSeriesIndexMap.set(serieIndex, range);
    clearTimeout(this.redrawTImeOut);


    DGDrawingServiceGlobal.drawingService().notificationDisplayer.drawAction(true);

    this.redrawTImeOut=setTimeout(()=>{
        DGDrawingServiceGlobal.drawingService().notificationDisplayer.drawAction(true);
    },1000)
  
 
  }
  
}
